<template>
    <div class="auth-container">
        <div class="module-box">
            <h4 class="card-headers">
                <el-icon>
                    <Expand />
                </el-icon>
                应用套件分组
                <el-tooltip class="box-item" effect="dark" content="新增应用套件分组" placement="top-start">
                    <el-icon class="circlePlusFilled">
                        <CirclePlusFilled color="var(--theme-color)" @click="handleAddAppkitGroup()" />
                    </el-icon>
                </el-tooltip>
            </h4>
            <ul>
                <li @click="changeAppkitGroup(null)" :class="!currentClickGroupId ? 'active' : ''">全部</li>
                <li
                    v-for="item in configGroupList"
                    :key="item.id"
                    @click="changeAppkitGroup(item.id)"
                    class="li-item"
                    :class="item.id == currentClickGroupId ? 'active' : ''"
                >
                    <span>{{ item.name }}</span>
                    <el-dropdown class="dot">
                        <span class="ellipsis">···</span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item @click="handlePutAppkitGroup(item)">修改</el-dropdown-item>
                                <el-dropdown-item @click="handleDelAppkitGroup(item)">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </li>
            </ul>
        </div>
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <el-button type="primary" :icon="Plus" @click="handleAppkit()">添加</el-button>
                    <el-button :icon="DCaret" @click="handleSort">一键排序</el-button>
                </div>
            </template>
            <el-table
                :data="configItemList"
                v-loading="tableLoading"
                border
                row-key="id"
                style="width: 100%"
                class="li-item"
                max-height="750"
            >
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column prop="name" label="套件名称">
                    <template #default="{ row }">
                        <span v-if="row.kit_type === 1" class="name" @click="$router.push({ path: `${row.url}` })">
                            {{ row.name }}
                        </span>
                        <span v-else class="name" @click="pushUrl(row.url)">{{ row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="group_name" label="所属分组" width="150"></el-table-column>
                <el-table-column prop="kit_type" label="套件类型" width="100">
                    <template #default="{ row }">
                        <div v-if="row.kit_type == 1">本地</div>
                        <div v-else>外链</div>
                    </template>
                </el-table-column>
                <el-table-column prop="icon_url" label="上传图标" width="100">
                    <template #default="{ row }">
                        <img :src="row.icon_url" style="width: 50px" alt="" />
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template #default="{ row }">
                        <el-tag v-if="row.status == 1">正常</el-tag>
                        <el-tag v-else type="danger">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="list_order" label="排序值" width="130">
                    <template #default="scope">
                        <el-input-number
                            style="width: 100px"
                            type="number"
                            v-model="scope.row.list_order"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                            size="small"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="View" @click="onShowClick(row)">查看</el-button>
                        <el-button v-permission="['appkit:put']" type="primary" link :icon="Edit" @click="handlePutAppkit(row)">
                            编辑
                        </el-button>
                        <el-button
                            v-permission="['appkit:remove']"
                            type="primary"
                            link
                            :icon="Delete"
                            @click="handleDelAppkit(row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>

        <item-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :formId="ItemId"
            @updateForm="getAppkitListTableData"
            :group="currentClickGroupId"
            :groupList="configGroupList"
            :modList="modList"
        ></item-dialog>
        <group-dialog
            v-model="groupDialogVisible"
            :isForm="isForm"
            :formId="GroupId"
            @updateForm="getAppkitGroupListData"
        ></group-dialog>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { CirclePlusFilled, DCaret, Delete, Edit, Plus, View } from '@element-plus/icons'
import { delAppkitGroup, getAppkitGroupOptionLists } from '@/api/appkitgroup'
import { batchSort, delAppkit, getAppkitOptionLists } from '@/api/appkit'
import ItemDialog from './components/itemDialog.vue'
import groupDialog from './components/groupDialog.vue'
import { getModuleOptionLists } from '@/api/module'

const tableLoading = ref(true)
const modList = ref([])
const configGroupList = ref([])
const configItemList = ref([])
const total = ref(0)
const page = ref(1)
const size = ref(10)
const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const groupDialogVisible = ref(false)
const ItemId = ref('')
const GroupId = ref('')
const currentClickGroupId = ref(null)

const pushUrl = (e) => {
    const url = window.open('about:blank')
    url.location.href = e
}

const getAppkitListTableData = () => {
    appkitListData({ group: currentClickGroupId.value, page: page.value, page_size: size.value })
}
const changeAppkitGroup = (id) => {
    currentClickGroupId.value = id
    page.value = 1
    getAppkitListTableData()
}

const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getAppkitListTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getAppkitListTableData()
}
// 查看开放应用
const onShowClick = (row) => {
    ItemId.value = row.id
    isForm.value = false
    formDialogVisible.value = true
}
// 删除开放应用分组
const handleDelAppkitGroup = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delAppkitGroup(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getAppkitGroupListData()
            currentClickGroupId.value = null
        })
        .catch(() => {})
}
// 删除开放应用
const handleDelAppkit = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delAppkit(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getAppkitListTableData()
        })
        .catch(() => {})
}

// 新增开放应用
const handleAppkit = async () => {
    isForm.value = true
    formDialogVisible.value = true
}

// 新增开放应用分组
const handleAddAppkitGroup = async () => {
    isForm.value = true
    groupDialogVisible.value = true
}

// 修改开放应用
const handlePutAppkit = async (item) => {
    ItemId.value = item.id
    isForm.value = true
    formDialogVisible.value = true
}
// 修改开放应用分组
const handlePutAppkitGroup = async (item) => {
    GroupId.value = item.id
    isForm.value = true
    groupDialogVisible.value = true
}

// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) ItemId.value = ''
})
watch(groupDialogVisible, (val) => {
    if (!val) GroupId.value = ''
})

// 获取模块选项列表数据
const getModuleListData = async () => {
    const data = await getModuleOptionLists()
    modList.value = data
}

// 获取开放应用分组选项列表数据
const getAppkitGroupListData = async () => {
    configGroupList.value = await getAppkitGroupOptionLists()
}

// 获取开放应用选项列表数据
const appkitListData = async (data) => {
    tableLoading.value = true
    const res = await getAppkitOptionLists(data)
    tableLoading.value = false
    configItemList.value = res.lists
    total.value = res.total
}
const getList = async () => {
    await getModuleListData()
    await getAppkitGroupListData()
    await getAppkitListTableData()
}
onMounted(() => {
    getList()
})

const selectAuthId = ref('') // 点中的模块id
const parentId = ref('') // 添加的时候选择的父节点
const modId = ref('') // 添加的时候选择的父节点的模块

// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectAuthId.value = ''
        parentId.value = ''
        modId.value = ''
    }
})

// 一键排序
const handleSort = async () => {
    const soreObj = {}
    const fn = async (data) => {
        data.forEach((ele) => {
            soreObj[ele.id] = ele.list_order
            if (ele.children) {
                fn(ele.children)
            }
        })
    }
    if (configItemList.value.length === 0) return
    await fn(configItemList.value)
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getAppkitListTableData()
}
</script>

<style lang="scss" scoped>
.hover-class {
    display: flex !important;
    justify-content: center !important;
    color: var(--theme-color) !important;
    cursor: pointer;
}
.el-table_1_column_2 {
    width: 400px !important;
}
.el-table_1_column_3 {
    width: 400px !important;
}
.dot {
    box-shadow: none !important;
    align-items: center;
}

.card-headers {
    display: flex;
    align-items: center;
    .circlePlusFilled {
        flex: 1;
        margin-left: 30px;
    }
}
.li-item {
    align-items: center;
    display: flex;
    justify-content: space-between;
    overflow-x: auto;
}
.ellipsis {
    color: var(--theme-color);
    font-size: 16px;
}
.ellipsis:focus-visible {
    outline: none;
}
.auth-container {
    display: flex;
    border-radius: 15px;
    // height: calc(100vh - 125px);
    .noBorder {
        border-bottom-right-radius: 15px;
    }
    .module-box {
        width: 180px;
        height: calc(100vh - 110px);
        background-color: #fafcfe;
        padding: 5px 0;
        box-sizing: border-box;
        font-size: 14px;
        border-right: 1px solid #d9d9e1;
        margin-top: -10px;
        border-bottom-left-radius: 8px;

        h4 {
            padding: 10px 10px;
            line-height: 28px;
            font-weight: normal;
            color: #7c7e82;
            font-size: 14px;
            display: flex;
            align-items: center;
            margin-left: 10px;
        }

        li {
            padding: 12px 20px;
            cursor: pointer;
            position: relative;
            color: #232323;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                background-color: var(--el-color-primary-light-9);
            }
        }

        .active {
            background-color: var(--el-color-primary-light-9);

            &::after {
                position: absolute;
                right: -1px;
                top: 0;
                content: '';
                width: 2px;
                height: 100%;
                background-color: #4291f7;
            }
        }
        .cell {
            width: 250px !important;
        }
    }

    .el-card {
        width: calc(100% - 150px);
        overflow-y: auto;
    }
}
.name {
    color: #337ab7;
    cursor: pointer;
}
.pagination {
    float: right;
}
.el-card {
    overflow-y: auto;
    overflow-x: auto;
}
</style>
